/**
 * Map Marker & Area picker
 * @author Gabriel Memmel @gabimem
 * @copyright MASCREATIVO.com
 * @since 2013-12-11
 * @version 2019-04-11
 * Se sacÃ³ el evento window.load, ya que se usa siempre dentro del ready de jQuery
 */
(function ($) {
    $.extend($.fn, {
        megaMaps: function (options) {
            var $el = this;
            options = $.extend({
                latitude: 0,
                longitude: 0,
                zoom: 15,
                areas: '',
                title: '',
                showMarker: true,
                editMarker: false,
                showArea: false,
                editArea: false,
                onchange: null,
                iconMarker: null
            }, options);

            if (parseInt(options.zoom || 0) === 0) {
                options.zoom = 15;
            }

            $el.data('areas', []);
            $el.data('marker', null);
            $el.data('options', options);

            function onchange() {
                if (typeof (options.onchange) === 'function') {
                    options.onchange({
                        latitude: options.latitude,
                        longitude: options.longitude,
                        zoom: options.zoom,
                        areas: options.areas
                    });
                }
            }

            function updateAreas() {
                var points = [];
                for (i in $el.data('areas')) {
                    var vertices = $el.data('areas')[i].getPath(); // MVCArray
                    var pointsArray = []; //list of polyline points
                    for (var j = 0; j < vertices.getLength(); ++j) {
                        var xy = vertices.getAt(j); //LatLang for a polyline
                        var item = xy.lat() + ',' + xy.lng();
                        pointsArray.push(item);
                    }
                    points.push(pointsArray.join(';'));
                }

                options.areas = points.join('|');
            }

            function initMap() {
                var asuncionLatlng = new google.maps.LatLng(-25.294682, -57.641501);
                var myLatlng = new google.maps.LatLng(options.latitude, options.longitude);
                var mapOptions = {};

                if (options.latitude === undefined || options.longitude === undefined || options.latitude == null || options.longitude == null || (options.latitude == 0 && options.longitude == 0)) {
                    //Si no se pasaron las coordenadas, se muestra asunciÃ³n con el zoom en 10
                    mapOptions = {
                        center: asuncionLatlng,
                        zoom: 10
                    };
                }
                else {
                    mapOptions = {
                        center: myLatlng,
                        zoom: parseInt(options.zoom)
                    };
                }

                var map = new google.maps.Map($el.get(0), mapOptions);

                $el.data('map', map);

                if (options.showMarker) {
                    $el.data('marker', new google.maps.Marker({
                        position: myLatlng,
                        draggable: options.editMarker,
                        map: map,
                        title: options.title,
                        icon: options.iconMarker
                    }));


                    $el.on('moveMarker', function (e, latitude, longitude) {
                        var latlng = new google.maps.LatLng(latitude, longitude);
                        $el.data('marker').setPosition(latlng);
                        $el.data('map').setCenter(latlng);
                        options.latitude = latitude;
                        options.longitude = longitude;
                        onchange();
                    });
                }

                if (options.showArea) {
                    var areas = options.areas.split('|');
                    if (areas.length > 0) {
                        for (i in areas) {
                            if (areas[i] !== '') {
                                var pointsArray = [];
                                var points = areas[i].split(';');
                                if (points.length > 0) {
                                    for (j in points) {
                                        if (points[j] !== '') {
                                            if (points[j].indexOf(',') > -1) {
                                                var coords = points[j].split(',');
                                                pointsArray.push(new google.maps.LatLng(coords[0], coords[1]));
                                            }
                                        }
                                    }
                                }

                                if (pointsArray.length > 0) {
                                    var area = new google.maps.Polygon({
                                        paths: pointsArray,
                                        strokeColor: '#006600',
                                        strokeOpacity: 1,
                                        strokeWeight: 2,
                                        fillColor: '#006600',
                                        fillOpacity: 0.3,
                                        clickable: true,
                                        editable: options.editArea
                                    });

                                    area.setMap(map);

                                    google.maps.event.addListener(area, 'mouseup', function (e) {
                                        updateAreas();
                                        onchange();
                                    });

                                    $el.data('areas').push(area);

                                    updateAreas();
                                }
                            }
                        }
                    }
                }

                if ((options.showMarker && options.editMarker) || (options.showArea && options.editArea)) {

                    var dwMode = null;
                    var dwModes = [];
                    if (options.editMarker) {
                        dwMode = google.maps.drawing.OverlayType.MARKER;
                        dwModes.push(google.maps.drawing.OverlayType.MARKER);
                    }
                    if (options.editArea) {
                        dwModes.push(google.maps.drawing.OverlayType.POLYGON);
                    }

                    var drawingManager = new google.maps.drawing.DrawingManager({
                        drawingMode: dwMode,
                        drawingControl: true,
                        drawingControlOptions: {
                            position: google.maps.ControlPosition.TOP_CENTER,
                            drawingModes: dwModes
                        },
                        markerOptions: {
                            clickable: true,
                            draggable: true
                        },
                        polygonOptions: {
                            fillColor: '#006600',
                            fillOpacity: .3,
                            strokeWeight: 2,
                            clickable: true,
                            editable: true,
                            zIndex: 1
                        }
                    });
                    drawingManager.setMap(map);

                    //MARKER
                    if (options.editMarker) {
                        google.maps.event.addListener(drawingManager, 'markercomplete', function (el) {
                            $el.data('marker').setMap(null);
                            $el.data('marker', el);

                            options.latitude = el.getPosition().lat();
                            options.longitude = el.getPosition().lng();

                            google.maps.event.addListener($el.data('marker'), 'dragend', function (el) {
                                options.latitude = el.latLng.lat();
                                options.longitude = el.latLng.lng();
                            });

                            onchange();
                        });

                        google.maps.event.addListener($el.data('marker'), 'dragend', function (el) {
                            options.latitude = el.latLng.lat();
                            options.longitude = el.latLng.lng();

                            onchange();
                        });
                    }

                    //POLYGON
                    if (options.editArea) {

                        google.maps.event.addListener(drawingManager, 'polygoncomplete', function (el) {
                            drawingManager.setDrawingMode(null);
                            google.maps.event.addListener(el, 'mouseup', function (e) {
                                updateAreas();
                                onchange();
                            });

                            $el.data('areas').push(el);

                            updateAreas();
                            onchange();
                        });

                        var controlDiv = $('<div>').addClass('custom-control').attr('title', 'Borrar el area marcada').on('click', function () {
                            drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
                            for (i in $el.data('areas')) {
                                $el.data('areas')[i].setMap(null);
                            }
                            $el.data('areas', []);

                            options.areas = '';

                            onchange();
                        }).append('<img src="img/icon-remove-polygon.png" />');

                        map.controls[google.maps.ControlPosition.TOP_CENTER].push(controlDiv.get(0));
                    }

                    //ZOOM
                    google.maps.event.addListener(map, 'zoom_changed', function (el) {
                        options.zoom = map.getZoom();
                        onchange();
                    });

                    onchange();
                }
            }

            // google.maps.event.addDomListener(window, 'load', initMap);

            initMap();

            return this;
        }
    });
})(jQuery);